import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { isNullOrUndefined } from '../../extensions';
var FieldComponent = /** @class */ (function () {
    function FieldComponent() {
        this.mode = 'input';
        this.maxlength = '4000';
        this.type = 'text';
        this.class = 'text';
        this.placeholder = '';
        this.isRequired = false;
        this.isSelectedOnInitial = false;
        this.onIconClick = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onKeyPressUp = new EventEmitter();
        this.onEnterKeyUp = new EventEmitter();
    }
    FieldComponent.prototype.ngOnInit = function () {
        if (this.isSelectedOnInitial) {
            this.input.nativeElement.select();
        }
    };
    Object.defineProperty(FieldComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            if (newValue === this._value || (isNullOrUndefined(this._value) && isNullOrUndefined(newValue))) {
                return;
            }
            this._value = newValue;
            if (this._notifyChange && this.formControl && this.formControl.value !== newValue) {
                this._notifyChange(newValue);
            }
            this.updateErrorText();
        },
        enumerable: true,
        configurable: true
    });
    FieldComponent.prototype.writeValue = function (newValue) {
        this._value = newValue;
    };
    FieldComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    FieldComponent.prototype.registerOnTouched = function (fn) {
    };
    FieldComponent.prototype.focus = function () {
        this.isFocused = true;
        this.wrap.nativeElement.style.backgroundColor = 'rgb(187, 225, 246)';
        this.onFocus.emit();
    };
    FieldComponent.prototype.onBlur = function () {
        this.isFocused = false;
        this.updateErrorText();
        this.wrap.nativeElement.style.backgroundColor = 'transparent';
    };
    FieldComponent.prototype.iconClick = function () {
        this.onIconClick.emit();
    };
    FieldComponent.prototype.clear = function () {
        this.value = '';
        this.onClear.emit();
    };
    FieldComponent.prototype.onKeyup = function (key) {
        if (key && key.key === 'Enter') {
            this.onEnterKeyUp.emit(key);
        }
        else {
            this.onKeyPressUp.emit(key);
        }
    };
    FieldComponent.prototype.updateErrorText = function () {
        this.errorText = '';
        if (this.formControl && this.formControl.dirty && this.formControl.errors) {
            for (var _i = 0, _a = Object.keys(this.formControl.errors); _i < _a.length; _i++) {
                var key = _a[_i];
                if (!!this.customErrorTexts) {
                    var customErrorText = this.customErrorTexts[key];
                    if (customErrorText) {
                        this.errorText = customErrorText;
                        return;
                    }
                }
                switch (key) {
                    case 'required':
                        return this.errorText = 'This field is required';
                    case 'incorrectEmailFormat':
                        return this.errorText = 'Incorrect email format';
                }
            }
        }
    };
    return FieldComponent;
}());
export { FieldComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/field/field.component.ts.pre-build-optimizer.js